/*!
 * @Author: leo
 * @Date: 2019-12-25 20:55:00
 * @Last Modified by: leo
 * @Last Modified time: 2019-12-25 20:55:00
 * @Instruduction: 路由权限状态
 */

import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import { RouteConfig } from 'vue-router'
import { constantRoutes, securityConstantRoutes } from '@/router'
import adminRoutes, { findAdminRoutes, filterIsVisible } from '@/router/admin'
import store from '@/store'

const hasPermission = (roles: Array<string | number>, route: RouteConfig) => {
    if (route.meta && route.meta.roles) {
        return roles.some(role => route.meta.roles.includes(role))
    } else {
        return true
    }
}

// 普通用户、管理员、超级管理员、测试人员
enum identity { common = 0, admin = 1, super = 2, security = 3 }

export const filterAsyncRoutes = (routes: RouteConfig[], roles: Array<string | number>) => {
    const res: RouteConfig[] = []
    routes.forEach(route => {
        const r = { ...route }
        if (hasPermission(roles, r)) {
            if (r.children) {
                r.children = filterAsyncRoutes(r.children, roles)
            }
            res.push(r)
        }
    })
    return res
}

export interface IPermissionState {
    routes: RouteConfig[]
    dynamicRoutes: RouteConfig[]
}

@Module({ dynamic: true, store, name: 'permission' })
class Permission extends VuexModule implements IPermissionState {
    public role: number = 0
    public routes: RouteConfig[] = []
    public dynamicRoutes: RouteConfig[] = []

    @Mutation
    private SET_ROUTES(routes: RouteConfig[]) {
        const routesClone = constantRoutes.slice()
        const indexRouteIdx = routesClone.findIndex((route: RouteConfig) => route.path === '/')
        routesClone.splice(indexRouteIdx + 1, 0, ...routes)
        this.routes = this.role === identity.security ? securityConstantRoutes : routesClone
        this.dynamicRoutes = routes
    }

    @Mutation
    private SET_ROLE(role: number) {
        this.role = role
    }

    @Action
    public GenerateRoutes(role: number) {
        let accessedRoutes: RouteConfig[] = []
        // 管理员, 超级管理员
        const hasMoreRoutes = [identity.admin, identity.super].includes(role)
        if (hasMoreRoutes) {
            accessedRoutes = adminRoutes
        } else {
            // 对普通用户增加部分管理员的路由
            const allowRouteName = ['UserDetail']
            accessedRoutes = findAdminRoutes(allowRouteName)
            accessedRoutes.forEach(filterIsVisible)
        }
        this.SET_ROLE(role)
        this.SET_ROUTES(accessedRoutes)
    }
}

export const PermissionModule = getModule(Permission)
